import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../core/common-service/common.service';
import { RemotePriceChangeService } from '../remote-price-change-service/remote-price-change.service';
import { PogDexDiscrepancyDisplayItem, PogDexDiscrepancySearchDetail, PogDexDiscrepancySearchItem, PogDexDiscrepancySearchMetadata, PogDexDiscrepancySearchRequest, RPCDexPriceDiscrepenciesFilter, RPCDexPriceDiscrepenciesFilterItemsResponse, RPCMachineDeviceCompatibilityFilter, RPCMachineDeviceCompatibilityFilterItemsResponse, RPCMachineDeviceCompatibilityItemsRequest, RPCTrackStatusFilterItemsResponse } from '../remote-price-change-service/remote-price-change.model';
import { ISubscription } from 'rxjs-compat/Subscription';
import { HttpErrorResponse, HttpUrlEncodingCodec } from '@angular/common/http';
import { FilterBarService } from '../../shared/filter-bar-service/filter-bar.service';
import { filter } from 'rxjs-compat/operator/filter';
import * as moment from 'moment';

@Component({
  selector: 'dex-price-discrepancies',
  templateUrl: './dex-price-discrepancies.component.html',
  styleUrls: ['./dex-price-discrepancies.component.scss']
})
export class DexPriceDiscrepanciesComponent implements OnInit {
  Math = Math;
  generating: boolean;
  isRefreshingPage: boolean;
  responseMessage: string;
  errorMessage: string;
  majorAccountId: number;
  vendorCode: string;
  machineNumber: number;
  accLocList: number[];
  pogDexDiscrepancyInfos:  PogDexDiscrepancySearchItem[];
  pogDexDiscrepancySearchItemSubject: ISubscription;
  pogDexDiscrepancySearchMetadataSubject: ISubscription;
  rpcDexPriceFilterSubject: ISubscription;
  gridDisplayLines: PogDexDiscrepancyDisplayItem[];
  httpErrorResponseSubject: ISubscription;
  isSelectAllActivated: boolean = false;
  // params = ['routes', 'accounts','machine-search', 'status', 'rpcActivation', 'buttons', 'maintenance'];
  params = ['routes', 'accounts','status', 'rpcActivation', 'rpcDexPriceDiscrepancies', 'buttons', 'dexPriceDiscrepancy'];

  completedStatusCodes = ['COMPLETED','VENDOR_COMPLETED'];
  errorStatusCodes     = ['ERROR','VENDOR_ERROR','REQUEST_ERROR'];
  inProcessStatusCodes = ['IN_PROCESS','REQUEST_QUEUED','VENDOR_ACCEPTED'];

  pageIsDirty: boolean;
  freshPage = true;
  filterPosition = 'in';
  view = 'list';
  isMobile = false;

  page = 1;
  pageSize = 100;
  totalNumberOfItems = 0;
  sortDirection: string;
  sortColumn: string;
  routeIDList: number[];

  @ViewChild('operationFilter') operationFilter;
  pageTopMessage: string;

  constructor(private _common: CommonService,
              private _rpcService: RemotePriceChangeService,
              private _filterBarService: FilterBarService) 
  {
    this._common.setCurrentPage('RPC DEX Price Discrepancies');
  }

  ngOnInit() {
    this.generating = false;
    this.pogDexDiscrepancyInfos = new Array();
    this.gridDisplayLines = new Array();
    this.resetPage();
    this.setupSubjects();
    this._rpcService.onRPCPriceDiscrepanciesDataReadyEventEmitter.subscribe(data => {
      this.pogDexDiscrepancyInfos.forEach(x => x.isCollapsed = true);
      this.buildDisplayLines();
    }, error => {
      this.errorMessage = error;
    });
    this._filterBarService.submitRPCEvent.subscribe(data => {
      this.submitRPC();
    });
    this._filterBarService.selectedMajorAcct.subscribe(data => {
      this.majorAccountId = data;
    });
    this.rpcDexPriceFilterSubject = this._filterBarService.rpcDexPriceFilterUpdate.subscribe((data: RPCDexPriceDiscrepenciesFilter) => {
      this.vendorCode = data.vendorCode; 
      this.machineNumber = data.machineNumber;
    });    
    this.pageIsDirty = false;
  }

  setupSubjects() {

    this._rpcService.GetRPCDexPriceDiscrepencyFilterData().subscribe((data: RPCDexPriceDiscrepenciesFilterItemsResponse) => {
      this.fillMessages(data);
    });

    this.pogDexDiscrepancySearchItemSubject = this._rpcService.pogDexDiscrepancySearchItemSubject.subscribe((data: PogDexDiscrepancySearchItem[]) => {
      console.log("SEARCH REVIEW Result::",data);
      this.pogDexDiscrepancyInfos = data; 
      let totalCount = this.pogDexDiscrepancyInfos == null || this.pogDexDiscrepancyInfos.length == 0 ? 0 : -999;
      this.totalNumberOfItems = totalCount;     
      this.responseMessage = this.pogDexDiscrepancyInfos.length == 0 ? "There are no results found." : "";           
      this.isRefreshingPage = false;
    });

    this.pogDexDiscrepancySearchMetadataSubject = this._rpcService.pogDexDiscrepancySearchMetadataSubject.subscribe((data:PogDexDiscrepancySearchMetadata) =>
    {
      console.log("SEARCH REVIEW Result Metadata", data);
      this.totalNumberOfItems = data.totalItemCount;
    });

    this.httpErrorResponseSubject = this._rpcService.httpErrorResponseSubject.subscribe((httpErrorResponse:HttpErrorResponse)=> {
      this.isRefreshingPage = false;
      let theErrorMessage = '';
      let error = httpErrorResponse.error;
      if (error == null || error == undefined) {
        theErrorMessage = `Error. Failure: ${httpErrorResponse.statusText} (Details: ${httpErrorResponse.message})`;
      } else {
        theErrorMessage = `Error:${error.title} Failure: ${httpErrorResponse.statusText} (Details: ${httpErrorResponse.message} ${error.detail})`;
      }
      this.errorMessage = theErrorMessage.length <= 400 ? theErrorMessage : theErrorMessage.substring(0, 400) + '...';
    });

    this._rpcService.onRPCRequestBeginEventEmitter.subscribe(()=> {
      this._filterBarService.setSubmitRPCEnabled(false);
    });
    this._rpcService.onRPCRequestEndEventEmitter.subscribe(()=> {
      //Used for after the last item is processed, to request button to be enabled
      this._filterBarService.setSubmitRPCEnabled(true);
    });
    this._rpcService.onRPCRequestChangeEventEmitter.subscribe((updateItem:PogDexDiscrepancySearchItem)=> {
      //let updateItem = data as PogDexDiscrepancySearchItem;
      if (updateItem != null && updateItem != undefined) {
        let findItem = this.gridDisplayLines.find(x => x.machineNumber == updateItem.machineNumber); // Find the matching "header" item
        if (findItem != null && findItem != undefined) {
          findItem.requestStatusCode = updateItem.statusCode;
          findItem.rpcSendDate = updateItem.rpcSendDate;
          findItem.rpcSend = false;
        }
      }
    });
  }

  onApplyFilters(newFilters) {   
    const searchValue = this._filterBarService.machineSearch.value;
    if (searchValue != undefined && searchValue.length > 0 && isNaN(Number(searchValue))) {
      this._filterBarService.machineSearchError = 'Machine search must be a number';
      return;
    }

    const request = this.buildSearchRequest(newFilters);
    this.search(request);
  }

  pageChanged() {
    this.onApplyFilters(false);
    this.isSelectAllActivated = false;
    window.scrollTo(0, 0);
  }
  
  private buildSearchRequest(newRequest: boolean) {
    let request = new PogDexDiscrepancySearchRequest();
    request.machineNumber = Number(this._filterBarService.machineSearch.value);
    request.costCenterID = Number(this._common.getOperation().operationNo);
    request.majorAccountId = this.majorAccountId;
    request.vendorCode     = this.vendorCode;
    request.machineNumber  = this.machineNumber;
    request.accountLocationList = this.getAccLocationArray();

    let filterDeviceStatusCode = this._filterBarService.rpcActivation.value.toUpperCase();
    let deviceStatusCode = '';
    switch (filterDeviceStatusCode)
    {
      case 'DISABLED':
        deviceStatusCode='DISABLED';
        break;
      case 'ENABLED':
        deviceStatusCode='ENABLED';
        break;
      case null:
      default:
        deviceStatusCode = '';
        break;
    }
    request.deviceStatusCode = deviceStatusCode;

    let filterRequestStatusCode = this._filterBarService.status.value.toUpperCase();
    let requestStatusCode = '';
    switch (filterRequestStatusCode) 
    {
      default:
      requestStatusCode = filterRequestStatusCode;
    }
    request.requestStatusCode = requestStatusCode;

    this.page = newRequest ? 1 : this.page;
    request.pageNumber = this.page;
    request.pageSize = this.pageSize;
    request.sortColumn = this.sortColumn;
    request.sortDirection = this.sortDirection;
    request.routeIDList = this.getRouteArray();
    console.log("Search request:",request);
    return request;
  }

  private getRouteArray() {
    this.routeIDList = new Array();
    if (this._filterBarService.routes.value) {
      for (let i = 0; i < this._filterBarService.routes.value.length; i++) {
        if(this._filterBarService.routes.value[i].selected) {  
          this.routeIDList.push(this._filterBarService.routes.value[i].routeID);
        }
      }
    }  
    return this.routeIDList;
  }

  private getAccLocationArray() { 
    this.accLocList = new Array();
    if (this._filterBarService.accountLocationList.value != null) {
      for (let i = 0; i < this._filterBarService.accountLocationList.value.length; i++) {
        if(this._filterBarService.accountLocationList.value[i].selected) {
          this.accLocList.push(this._filterBarService.accountLocationList.value[i].id);
        }
      }
    }
   return this.accLocList;
 }

  private search(request: PogDexDiscrepancySearchRequest) {
    this.gridDisplayLines = new Array();
    this.freshPage = false;
    this.errorMessage = '';
    this.responseMessage = '';
    this.isRefreshingPage = true;
    this._rpcService.RunUpdateAndPogDexDiscrepancySearch(request);
  }

  private fillMessages(data: RPCDexPriceDiscrepenciesFilterItemsResponse) {
    let messagesText = "";
    const globalMessage = data.messages.find(x => x.costCenterID === null);
    const costCenterMessage = data.messages.find(x => x.costCenterID === Number(this._common.operation.operationNo));
    
    if (globalMessage != null && globalMessage.messageText !== null) {
      messagesText =  globalMessage.messageText;
    }

    if (costCenterMessage != null && costCenterMessage.messageText) {
      messagesText += ((messagesText !== "" ? "<br>" : "") + costCenterMessage.messageText);
    }

    this.pageTopMessage = messagesText;
  }

  resetPage() {
    this.isRefreshingPage = true;
    this._rpcService.Initialize();
    this._filterBarService.ResetFilterBar();
    this.isRefreshingPage = false;
  }

  onChangeView(view) {
    this.view = view;
    if (this.isMobile) {
      this.filterPosition = 'out';
    } else {
      this.filterPosition = view === 'grid' ? 'out' : 'in';
    }
  }

  getStatusColumnClass(item: PogDexDiscrepancyDisplayItem){
    switch (item.requestStatusCode) {
      case 'COMPLETED':
      case 'VENDOR_COMPLETED':
          return 'text-center greenCheck';
      case 'ERROR':
      case 'VENDOR_ERROR':
      case 'REQUEST_ERROR':
        return 'text-center redX';
      case 'IN_PROCESS':
      case 'REQUEST_QUEUED':
      case 'VENDOR_ACCEPTED':
            return 'text-center blueCircle';
      default:
        return 'text-center';
    }
  }
  getStatusIcon(item: PogDexDiscrepancyDisplayItem) {
    switch (item.requestStatusCode) {
      case 'COMPLETED':
      case 'VENDOR_COMPLETED':
        return '\u2713';
      case 'ERROR':
      case 'VENDOR_ERROR':
      case 'REQUEST_ERROR':
        return '\u274c';
      case 'IN_PROCESS':
      case 'REQUEST_QUEUED':
      case 'VENDOR_ACCEPTED':
        return '\u25ef';
      default:
        return '';
    }

    switch(item.deviceStatusCode) {
      case 'DISABLED':
        return '\u26d4'; // red circle with while horizontal line through it
        break;
    }

    return '';
  }
    
  showCurrency(value: number) {
    return typeof value == "number" ? value.toFixed(2) : "";
  }

  markAsDirty() {
    this.pageIsDirty = true;
  }

  buildDisplayLines() {
    let newGridDisplayLines = [];
    let originalGridDisplayLines = this.gridDisplayLines;

    this.pogDexDiscrepancyInfos.forEach((item) => {

      // Make the display item, but if it is a checkbox item, look for the original item to use to preserve the checkbox state of the item
      let displayItem = this.makeDisplayLineFromItem(item);
      if (this.isCheckboxItem(displayItem)) {
        let originalItem = originalGridDisplayLines.find(x=>x.machineId == displayItem.machineId);
        if (originalItem != null) {
          displayItem = originalItem;
        }
      }

      newGridDisplayLines.push(displayItem);

      if (!item.isCollapsed) {
        item.details.forEach((detail) => {
          newGridDisplayLines.push(this.makeDisplayLineFromDetail(detail, item))
        });
      }
    });

    this.gridDisplayLines = newGridDisplayLines;
  }

  private makeDisplayLineFromItem(item: PogDexDiscrepancySearchItem) {
    let result = new PogDexDiscrepancyDisplayItem();
    result.isHeaderItem     = true;
    result.accountName      = item.accountName;
    result.locationName     = item.locationName;
    result.routeNumber      = item.routeNumber;
    result.vendorCode       = item.vendorCode;
    result.deviceNo         = item.deviceNo;
    result.machineId        = item.machineID;
    result.machineNumber    = item.machineNumber;
    result.dexType          = item.dexType;
    result.selection        = item.selection;
    result.dexPrice         = item.dexPrice;
    result.currentPogPrice  = item.currentPogPrice;
    result.productLongName  = '';
    result.rpcOn            = item.rpcEnabled ? 'YES' + (item.rpcAutoSendEnabledInd ? '/AUTO' : '') : 'NO';
    result.rpcAutoSendEnabledInd = item.rpcAutoSendEnabledInd;
    result.rpcSend          = false;
    result.rpcSendDate      = item.rpcSendDate;
    result.deviceStatusCode = item.deviceStatusCode;
    result.requestStatusCode= item.requestStatusCode;
    result.isCollapsed      = item.isCollapsed;
    return result;
  }

  private makeDisplayLineFromDetail(detail: PogDexDiscrepancySearchDetail, item: PogDexDiscrepancySearchItem) {
    let result = new PogDexDiscrepancyDisplayItem();
    result.isHeaderItem     = false;
    result.accountName      = '';
    result.locationName     = '';
    result.deviceNo         = null;
    result.routeNumber      = null;
    result.dexType          = '';
    result.selection        = detail.selectionName;
    result.dexPrice         = detail.dexPrice;
    result.currentPogPrice  = detail.pogPrice;
    result.productLongName  = detail.productLongName
    result.rpcOn            = '';
    result.rpcSendDate      = null;
    result.requestStatusCode           = null;
    result.isCollapsed      = item.isCollapsed;
    return result;
  }

  collapseItem(item : PogDexDiscrepancyDisplayItem) {
    var itemInList : PogDexDiscrepancySearchItem = this.pogDexDiscrepancyInfos.find(x => x.deviceNo == item.deviceNo && x.machineID == item.machineId);
    itemInList.isCollapsed = !itemInList.isCollapsed;
    this.buildDisplayLines();
  }

  getSendCheckboxClass(item: PogDexDiscrepancyDisplayItem) {
    if (this.isCheckboxItem(item)){
      if (this.isCheckboxEnabled(item)) {
        return '';
      } else {
        return 'disabled-checkbox';
      }
    } 
    else {
      return 'hidden-checkbox';
    }
  }

  isCheckboxItem(item:PogDexDiscrepancyDisplayItem):boolean {
    return (
             item.isHeaderItem && 
             item.deviceStatusCode=="ENABLED" &&
             !this.inProcessStatusCodes.includes(item.requestStatusCode)
           );
  }

  isCheckboxEnabled(item:PogDexDiscrepancyDisplayItem): boolean {
    return item.rpcAutoSendEnabledInd != true;
  }

  getPageInfo() {
    return this.totalNumberOfItems;
  }

  onSelectAllChanged() {
    this.gridDisplayLines.forEach(item => {
      if (this.isCheckboxItem(item) && this.isCheckboxEnabled(item)) {
        item.rpcSend = this.isSelectAllActivated;
      }
    });
  }

  submitRPC() {
    let itemsToSend = new Array<PogDexDiscrepancySearchItem>();
    this.gridDisplayLines.forEach(item=> {
      if (item.rpcSend) {
        let findItem = this.pogDexDiscrepancyInfos.find(x=>x.machineNumber == item.machineNumber);
        if (findItem !== undefined) {
          itemsToSend.push(findItem);
        }
      }
    });
    this._rpcService.sendMachineDeviceSelectionPriceRequests(itemsToSend);
  }

  sortItems(sortAsc, columnName, boolValue) {
    this.sortColumn = columnName;
    this.sortDirection = sortAsc ? 'asc' : 'desc';
    let request : PogDexDiscrepancySearchRequest = this.buildSearchRequest(true);
    this.search(request);
    this.buildDisplayLines();
  }

  blankOutMinDate(e: Date){
    const minDateTime = new Date('0001-01-01T00:00:00').getTime();
    var dateTime = new Date(e);
    if (e==null || dateTime.getTime() === minDateTime)
      return '';
    else
      return moment(dateTime).format ("MM/DD/YYYY h:mm A");
  }

}
